import React, { useEffect, useState } from "react";
// import { ShiftMasterService } from "../services/ShiftMasterService";
import EmployeeProcessService from "../services/EmployeeProcessService";
import { useLoading } from "../Utils/LoadingContext";

const ShiftMaster = () => {
    const empcode = localStorage.getItem("empcode");
    const { setLoading } = useLoading();
    const [shiftList, setShiftList] = useState([]);
    const [plantList, setPlantList] = useState([]);

    const [form, setForm] = useState({
        ShiftID: null,
        PlantID: "",
        PlantName: "",
        ShiftCode: "",
        ShiftName: "",
        StartTime: "09:00",
        EndTime: "18:00",
        IsActive: true,
        IsOTApplicable: true,
        OTRoundOff: 0,
        IsNightShift: true,
        FullDayMinute: 0,
        LatArrivalMinute: 0,
        HFDayMinute: 0,
        OTMinute: 0,
        OTMaxMinutes: 0,
    });

    /* 🔹 Load plants only */
    useEffect(() => {
        loadPlants();
    }, []);

    const loadPlants = async () => {

        try {
            const plantRes = await EmployeeProcessService.getPlant(empcode);
            if (plantRes?.data?.statusCode === 200) {
                setPlantList(plantRes.data.result);
            }
        } catch (error) {
            console.error("Error loading plants:", error);
        }
    };

    /* 🔹 Load shifts by plant */
    const loadShiftsByPlant = async (plantId) => {
        if (!plantId) {
            setShiftList([]);
            return;
        }
        const res = await EmployeeProcessService.getShiftMaster(plantId);
        setShiftList(res.data.result);
    };

    /* 🔹 Handle form change */
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: type === "checkbox" ? checked : value,
        }));

        // ✅ When plant changes → load shifts
        if (name === "PlantID") {
            loadShiftsByPlant(value);
        }
    };

    /* 🔹 Edit */
    const handleEdit = (row) => {
        setForm({
            ShiftID: row.shiftID,
            PlantID: row.plantID,
            ShiftCode: row.shiftCode,
            ShiftName: row.shiftName,
            StartTime: row.startTime?.substring(0, 5),
            EndTime: row.endTime?.substring(0, 5),
            IsActive: row.isActive,
            IsOTApplicable: row.isActive,
            OTRoundOff: row.otRoundOff,
            IsNightShift: row.isNightShift,
            FullDayMinute: row.fullDayMinute,
            HFDayMinute: row.hfDayMinute,
            LatArrivalMinute: row.latArrivalMinute,
            OTMinute: row.otMinute,
            OTMaxMinutes: row.otMaxMinutes,
        });

        // reload shift list for selected plant
        loadShiftsByPlant(row.plantID);
    };

    /* 🔹 Save */
    const handleSubmit = async () => {
        if (!form.PlantID) {
            alert("Please select Plant");
            return;
        }

        await EmployeeProcessService.setShiftMaster(form);
        alert("Saved Successfully");

        loadShiftsByPlant(form.PlantID);

        // setForm({
        //     ...form,
        //     ShiftID: null,
        //     PlantID: "",
        //     PlantName: "",
        //     ShiftCode: "",
        //     ShiftName: "",
        //     StartTime: "",
        //     EndTime: "",
        //     IsActive: false,
        //     IsOTApplicable: false,
        //     OTRoundOff: 0,
        //     IsNightShift: false,
        //     FullDayMinute: 0,
        //     LatArrivalMinute: 0,
        //     HFDayMinute: 0,
        //     OTMinute: 0,
        //     OTMaxMinutes: 0,
        // });
    };

    /* 🔹 Get plant name */
    const getPlantName = (plantId) =>
        plantList.find((p) => p.id === plantId)?.name || plantId;

    return (
        <div className="container">
            <h4 className="mb-3">Shift Master</h4>

            {/* 🔹 FORM */}
            <div className="row g-2 mb-4 align-items-end">

                {/* Plant */}
                <div className="col-md-3">
                    <label className="form-label">Plant</label>
                    <select
                        name="PlantID"
                        className="form-select"
                        value={form.PlantID}
                        onChange={handleChange}
                    >
                        <option value="">-- Select Plant --</option>
                        {plantList.map((p) => (
                            <option key={p.id} value={p.id}>
                                {p.name}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="col-md-2">
                    <label className="form-label">Shift Code</label>
                    <input
                        name="ShiftCode"
                        className="form-control"
                        value={form.ShiftCode}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-3">
                    <label className="form-label">Shift Name</label>
                    <input
                        name="ShiftName"
                        className="form-control"
                        value={form.ShiftName}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-2">
                    <label className="form-label">Start</label>
                    <input
                        type="time"
                        name="StartTime"
                        className="form-control"
                        value={form.StartTime}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-2">
                    <label className="form-label">End</label>
                    <input
                        type="time"
                        name="EndTime"
                        className="form-control"
                        value={form.EndTime}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-2">
                    <label className="form-label">FullDayMinute</label>
                    <input
                        type="text"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        name="FullDayMinute"
                        className="form-control"
                        value={form.FullDayMinute}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-2">
                    <label className="form-label">HFDayMinute</label>
                    <input
                        type="text"
                        name="HFDayMinute"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        className="form-control"
                        value={form.HFDayMinute}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-2">
                    <label className="form-label">OTMinute MIN</label>
                    <input
                        type="text"
                        name="OTMinute"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        className="form-control"
                        value={form.OTMinute}
                        onChange={handleChange}
                    />
                </div>

                <div className="col-md-2">
                    <label className="form-label">OTMaxMinutes</label>
                    <input
                        type="text"
                        name="OTMaxMinutes"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        className="form-control"
                        value={form.OTMaxMinutes}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-2">
                    <label className="form-label">OTRoundOff</label>
                    <input
                        type="text"
                        name="OTRoundOff"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        className="form-control"
                        value={form.OTRoundOff}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-2">
                    <label className="form-label">LatArrivalMinute</label>
                    <input
                        type="text"
                        name="LatArrivalMinute"
                        onKeyDown={(e) => {
                            // Allow: backspace, delete, tab, escape, enter, arrows
                            if (
                                e.key === "Backspace" ||
                                e.key === "Delete" ||
                                e.key === "Tab" ||
                                e.key === "Escape" ||
                                e.key === "Enter" ||
                                (e.key >= "0" && e.key <= "9") ||
                                e.key.startsWith("Arrow")
                            ) {
                                return;
                            }

                            e.preventDefault(); // Block the key
                            alert("Only numbers are allowed.");
                        }}
                        className="form-control"
                        value={form.LatArrivalMinute}
                        onChange={handleChange}
                    />
                </div>
                <div className="col-md-2 form-check mt-4">
                    <input
                        type="checkbox"
                        name="IsActive"
                        className="form-check-input"
                        checked={form.IsOTApplicable}
                        onChange={handleChange}
                    />
                    <label className="form-check-label">IsOTApplicable</label>
                </div>
                <div className="col-md-2 form-check mt-4">
                    <input
                        type="checkbox"
                        name="IsNightShift"
                        className="form-check-input"
                        checked={form.IsNightShift}
                        onChange={handleChange}
                    />
                    <label className="form-check-label">IsNightShift</label>
                </div>
                <div className="col-md-2 form-check mt-4">
                    <input
                        type="checkbox"
                        name="IsActive"
                        className="form-check-input"
                        checked={form.IsActive}
                        onChange={handleChange}
                    />
                    <label className="form-check-label">Active</label>
                </div>

                <div className="col-md-2">
                    <button className="btn btn-primary w-100" onClick={handleSubmit}>
                        {form.ShiftID ? "Update" : "Save"}
                    </button>
                </div>
            </div>

            {/* 🔹 TABLE */}
            <table className="table table-bordered table-striped">
                <thead className="table-dark">
                    <tr>
                        <th>Plant</th>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Time</th>
                        <th>FullDay</th>
                        <th>HFDay</th>
                        <th>OTMIN</th>
                        <th>OTMax</th>
                        <th>OTRound</th>
                        <th>LatArrive</th>
                        <th>IsOT</th>
                        <th>IsNight</th>
                        <th>Active</th>
                        <th>Edit</th>
                    </tr>
                </thead>
                <tbody>
                    {shiftList.map((s) => (
                        <tr key={s.shiftID}>
                            <td>{getPlantName(s.plantID)}</td>
                            <td>{s.shiftCode}</td>
                            <td>{s.shiftName}</td>
                            <td>{s.startTime} - {s.endTime}</td>
                            <td>{s.fullDayMinute}</td>
                            <td>{s.hfDayMinute}</td>
                            <td>{s.otMinute}</td>
                            <td>{s.otMaxMinutes}</td>
                            <td>{s.otRoundOff}</td>
                            <td>{s.latArrivalMinute}</td>
                            <td>{s.isOTApplicable ? "Yes" : "No"}</td>
                            <td>{s.isNightShift ? "Yes" : "No"}</td>
                            <td>{s.isActive ? "Yes" : "No"}</td>
                            <td>
                                <button
                                    className="btn btn-sm btn-warning"
                                    onClick={() => handleEdit(s)}
                                >
                                    Edit
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

        </div>
    );
};

export default ShiftMaster;
